import React, { Component } from "react"
import { Dialog } from "@material-ui/core"
import './TwoButtonDialog.scss'

class TwoButtonDialog extends Component {
    render() {
        const {
            title,
            body,
            btn1String,
            btn2String,
        
            handleClickBtn1,
            handleClickBtn2,
            onClose,
        
            open,
            classOfBtnArea,
            classOfBtn1,
            clsssOfBtn2,
        } = this.props
        return (
            <>
                <Dialog open={open} onClose={onClose}>
                    <div className="two-button-dialog-container">
                        <div className='close'><img src='https://front.videomonster.com/images-u6yd72dy/web/close.svg' onClick={onClose} alt=''/></div>
                        { title && <div className='title'>{title}</div> }
                        { body && <div className='body'>{body}</div> }
                        <div className={`button-area ${classOfBtnArea}`}>
                            { btn1String && <div className={`two-button left ${classOfBtn1}`} onClick={handleClickBtn1} >{btn1String}</div> }
                            { btn2String && <div className={`two-button right ${clsssOfBtn2}`} onClick={handleClickBtn2} >{btn2String}</div> }
                        </div>
                    </div>
                </Dialog>
            </>
        );
    }
}

export default TwoButtonDialog
